import React, { useState, useEffect } from 'react';
import { getMeds, removeMed } from '../api/meds';
import { getRecalls } from '../api/fda';

export default function MyMeds({ onSelect }) {
  const [meds, setMeds] = useState(getMeds());
  const [recallStatus, setRecallStatus] = useState({});

  useEffect(() => {
    let cancelled = false;
    meds.forEach(async (med) => {
      const recalls = await getRecalls(med.name);
      if (cancelled) return;
      const ongoing = recalls.filter(r => r.status === 'Ongoing').length;
      setRecallStatus(prev => ({
        ...prev,
        [med.name.toLowerCase()]: { total: recalls.length, ongoing },
      }));
    });
    return () => { cancelled = true; };
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (meds.length === 0) return null;

  const handleRemove = (e, name) => {
    e.stopPropagation();
    removeMed(name);
    setMeds(getMeds());
  };

  return (
    <div className="my-meds">
      <div className="my-meds-header">
        <h2 className="my-meds-title">My Medications</h2>
        <p className="my-meds-subtitle">Saved on this device · recall status checked live</p>
      </div>
      <div className="my-meds-grid">
        {meds.map((med) => {
          const status = recallStatus[med.name.toLowerCase()];
          return (
            <button key={med.name} className="my-med-card" onClick={() => onSelect(med.name)}>
              <div className="my-med-top">
                <span className="my-med-name">{med.name}</span>
                <span
                  className="my-med-remove"
                  role="button"
                  tabIndex={0}
                  onClick={(e) => handleRemove(e, med.name)}
                  onKeyDown={(e) => { if (e.key === 'Enter') handleRemove(e, med.name); }}
                  title="Remove from my medications"
                >
                  ✕
                </span>
              </div>
              {med.genericName && <span className="my-med-generic">{med.genericName}</span>}
              <span className="my-med-tier" style={{ color: med.tierColor }}>{med.tier}</span>
              <span
                className={`my-med-recalls ${status?.ongoing > 0 ? 'my-med-recalls--active' : status?.total > 0 ? 'my-med-recalls--past' : ''} ${status?.total > 0 ? 'my-med-recalls--link' : ''}`}
                title={status?.total > 0 ? 'See recall details' : undefined}
                onClick={status?.total > 0 ? (e) => { e.stopPropagation(); onSelect(med.name, 'recalls'); } : undefined}
              >
                {!status
                  ? 'Checking recalls…'
                  : status.ongoing > 0
                    ? `🚨 ${status.ongoing} active recall${status.ongoing > 1 ? 's' : ''} — see details →`
                    : status.total > 0
                      ? `${status.total} past recall${status.total > 1 ? 's' : ''} · resolved →`
                      : '✓ No recalls'}
              </span>
            </button>
          );
        })}
      </div>
    </div>
  );
}
